"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
const react_1 = __importStar(require("react"));
const creatable_1 = __importDefault(require("react-select/creatable"));
require("./styles.scss");
const Autocomplete = (props) => {
    const { searchPlaceholder = "Search ...", label, onChange, value, disabled = false, options = [] } = props;
    const [selectedOption, setSelectedOption] = (0, react_1.useState)(value);
    const onSelectChange = (option) => {
        setSelectedOption(option || undefined);
        onChange === null || onChange === void 0 ? void 0 : onChange(option || undefined);
    };
    (0, react_1.useEffect)(() => {
        setSelectedOption(value);
    }, [value]);
    return (react_1.default.createElement("div", { className: "c-autocomplete" },
        label && react_1.default.createElement("label", { className: "c-autocomplete__label" }, label),
        react_1.default.createElement(creatable_1.default, { placeholder: searchPlaceholder, onChange: onSelectChange, options: options, classNamePrefix: "c-autocomplete", className: "c-autocomplete-container", value: selectedOption, isDisabled: disabled, isClearable: true, createOptionPosition: "first", formatCreateLabel: (text) => `Find: ${text}` })));
};
exports.Autocomplete = Autocomplete;
